import { format, parseISO } from 'date-fns'
import {formatForTimezone} from '../../modules/utilities/dates.js'
import { displayNumber } from '../../modules/utilities/numbers.js'
import { displayReportResults } from '../../modules/ui.js'

const reportTemplate = document.getElementById('tmpl-report-inventoryValuation')

export default class MTInventoryValuationReport extends HTMLElement {
    constructor() {
        super()
        this.attachShadow({ mode: 'open' })
        this.shadowRoot.appendChild(reportTemplate.content.cloneNode(true))

        this.effectiveDateElement = this.shadowRoot.querySelector(
            '.js-effective-date'
        )

        this.errorElement = this.shadowRoot.querySelector('#js-error-container')

        this.printElement = this.shadowRoot.querySelector('#js-print-report')
        this.printElement.addEventListener(
            'click',
            () => {
                this.dispatchEvent(new CustomEvent('printReportEvent'))
            },
            false
        )
    }

    set data(value) {
        const effectiveDate = document.querySelector('#effectiveDate').value

        const ed = parseISO(effectiveDate)
        this._data = value

        this._results = value.reportData

        this._summary = {
            receiveHead: value.receiveHead,
            liveHead: value.liveHead,
            shipHead: value.shipHead,
            deadHead: value.deadHead,
            deliveredCattleCostTotal: value.deliveredCattleCostTotal,
            deliveredCattleCostPerCWT: value.deliveredCattleCostPerCWT,
            costOfGainExpenseTotal: value.costOfGainExpenseTotal,
            sellingExpenseTotal: value.sellingExpenseTotal,
            profitExpenseTotal: value.profitExpenseTotal,
            feedyardExpenseTotal: value.feedyardExpenseTotal,
            expensesTotal: value.expensesTotal,
            salesTotal: value.salesTotal,
            expenseLessSaleTotal: value.expenseLessSaleTotal,
            effectiveDate: new Date(ed),
        }

        if (this._data.hasError) {
            this.displayError()
        } else {
            this.displaySummary()
            displayReportResults(this, '#js-iv-results-container')
        }
    }

    displayError() {
        console.log(this._data.errorMessage)
        this.errorElement.innerText = this._data.errorMessage
    }

    summaryTemplate(props) {
        return `
            <div class="summary-card">
                <dt class="summary-label">
                    Received Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.receiveHead,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Live Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.liveHead,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Shipped Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.shipHead,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Dead Head
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.deadHead,
                    1
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Total Delivered Cattle Cost
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.deliveredCattleCostTotal,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Delivered Cattle Cost / CWT
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.deliveredCattleCostPerCWT,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Total Cost of Gain Expenses
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.costOfGainExpenseTotal,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Total Selling Expenses
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.sellingExpenseTotal,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Total Profit / Loss Expenses
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.profitExpenseTotal,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Total Feed Yard Expenses
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.feedyardExpenseTotal,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Total Expenses
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.expensesTotal,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Total Sales
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.salesTotal,
                    2
                )}</dd>
            </div>
            <div class="summary-card">
                <dt class="summary-label">
                    Total Expenses Less Sales
                </dt>
                <dd class="summary-content summary-received-head">${displayNumber(
                    props.expenseLessSaleTotal,
                    2
                )}</dd>
            </div>
        `
    }

    displaySummary() {
        this.effectiveDateElement = this.shadowRoot.querySelector(
            '.js-effective-date'
        )
        console.log(this._summary.effectiveDate)
        this.effectiveDateElement.innerText = format(
            this._summary.effectiveDate,
            'MM/dd/yyyy'
        )
        this.summaryListElement = this.shadowRoot.querySelector(
            '#js-summary-list'
        )

        const summary = this.summaryTemplate(this._summary)

        this.summaryListElement.innerHTML = summary
    }

    locationResultsRow(props) {
        const averageInDate =
            props.INDATE !== null
                ? formatForTimezone(props.INDATE, 'MM/dd/yy')
                : ''

        return `
            <tr class="report-data--row">
                <td class="left lot">
                    ${props.LOT ?? ''}
                </td>
                <td class="right ownership-percentage">
                    ${displayNumber(props.OWNER_PERCENT, 1)}
                </td>
                <td class="left sex">
                    ${props.SEX ?? ''}
                </td>
                <td class="left origin">
                    ${props.ORIGIN ?? ''}
                </td>
                <td class="center average-in-date">
                    ${averageInDate}
                </td>
                <td class="right receive">
                    ${displayNumber(props.RECEIVE, 1)}
                </td>
                <td class="right head">
                    ${displayNumber(props.LIVE, 1)}
                </td>
                <td class="right head">
                    ${displayNumber(props.SHIP, 1)}
                </td>
                <td class="right head">
                    ${displayNumber(props.DEAD, 1)}
                </td>
                <td class="right in-weight">
                    ${displayNumber(props.PAYWEIGHT, 0)}
                </td>
                <td class="right current-weight">
                    ${displayNumber(props.CURRENTWEIGHT, 0)}
                </td>
                <td class="right dof">
                    ${displayNumber(props.DOF, 0)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.DELIVEREDCOST, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.DELIVEREDCOSTCWT, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.TOTALCOG, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.TOTALSELLING, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.TOTALPL, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.FEED_YARD_EXPENSE, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.TOTALEXP, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.TOTALSALES, 2)}
                </td>
                <td class="right cattle-cwt">
                    ${displayNumber(props.TOTALEXPENSE, 2)}
                </td>
            </tr>
        `
    }

    calculateLocationTotals(a, l) {
        console.log(l.HOME)
        return {
            receive: a.receive + l.RECEIVE,
            live: a.live + l.LIVE,
            shipped: a.shipped + l.SHIP,
            dead: a.dead + l.DEAD,
            inWeight: a.inWeight + l.PAYWEIGHT,
            curWeight: a.curWeight + l.CURRENTWEIGHT,
            dof: a.dof + l.DOF,
            cattleCost: a.cattleCost + l.DELIVEREDCOST,
            cog: a.cog + l.TOTALCOG,
            sell: a.sell + l.TOTALSELLING,
            pl: a.pl + l.TOTALPL,
            yard: a.yard + l.FEED_YARD_EXPENSE,
            totalExp: a.totalExp + l.TOTALEXP,
            totalSales: a.totalSales + l.TOTALSALES,
            totalExpLessSales: a.totalExpLessSales + l.TOTALEXPENSE,
			weights: {
                inWeight: a.weights.inWeight + l.PAYWEIGHT * l.RECEIVE,
                curWeight: a.weights.curWeight + l.CURRENTWEIGHT * l.LIVE,
                dof: a.weights.dof + l.DOF * l.RECEIVE,
            },
        }
    }

    locationTotalsAccumulator() {
        return {
            receive: 0,
            live: 0,
            shipped: 0,
            dead: 0,
            inWeight: 0,
            curWeight: 0,
            dof: 0,
            cattleCost: 0,
            cog: 0,
            sell: 0,
            pl: 0,
            yard: 0,
            totalExp: 0,
            totalSales: 0,
            totalExpLessSales: 0,
			weights: {
				inWeight: 0,
				curWeight: 0,
				dof: 0,
			},
        }
    }

    locationNoResultsTemplate(props) {
        return `
            <div class="mt-well mt-template-indent" data-location-id="${props.locationID}">
                <div class="mt-well--content">
                <h3 class="mt-report-title">${props.locationName}</h3>
                    <p>There are no results for ${props.locationName} during this timeframe.</p>
                </div>
            </div>
            `
    }

    locationResultsTemplate(props) {
        const total = props.data.reduce(
            this.calculateLocationTotals,
            this.locationTotalsAccumulator()
        )
        console.info({ total })
        return `
            <div class="mt-well" data-location-id="${props.locationID}" data-collapsible-id="${props.locationID}" data-collapsed="false">
                <div class="mt-well--content">
                    <h3 class="mt-report-title">
						<svg id="collapse-${props.locationID}" data-collapsed="false" class="h-3 w-3 md:h-6 md:w-6" fill="var(--color-action)" viewBox="-150 -350 900 900" height="1.5rem" aria-hidden="true" style="cursor:pointer;">
			            	<path name="expand-icon"
			                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z" />
			                <path name="collapse-icon"
			                  d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z" />
			            </svg>
						${props.locationName}
					</h3>
                    <div class="mt-table--container">
                    <table class="js-report--table mt-table">
                <thead class="mt-table--head">
                    <tr>
                        <th scope="col" class="left lot collapsed-hidden">
                            Lot
                        </th>
                        <th scope="col" class="right ownership-percentage collapsed-hidden">
                            <abbr title="Ownership Percentage">Owner%</abbr>
                        </th>
                        <th scope="col" class="left sex collapsed-hidden">
                            Sex
                        </th>
                        <th scope="col" class="left origin collapsed-hidden">
                            Origin
                        </th>
                        <th scope="col" class="center average-in-date collapsed-hidden">
                            <abbr title="Average In Date">Avg In Date</abbr>
                        </th>
                        <th scope="col" class="right receive">
                            <abbr title="Receive">Rec</abbr>
                        </th>
                        <th scope="col" class="right live">
                            Live
                        </th>
                        <th scope="col" class="right ship">
                            Ship
                        </th>
                        <th scope="col" class="right dead">
                            Dead
                        </th>
                        <th scope="col" class="right average-in-weight">
                            <abbr title="In Weight">In Wt</abbr>
                        </th>                     
                        <th scope="col" class="right current-weight">
                            <abbr title="Current Weight">Curr Wt</abbr>
                        </th>
                        <th scope="col" class="right dof">
                            <abbr title="Days on Feed">DOF</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Delivered Cattle Cost">Cattle Cost</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt collapsed-hidden">
                            <abbr title="Delivered Cattle Cost / CWT">Cattle / CWT</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Total Cost of Gain Expense">COG Exp</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Total Selling Expense">Sell Exp</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Total Profit/Loss Expense">P/L Exp</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Total Feedyard Expense">Yard Exp</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Total Expense">Tot Exp</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Total Sales">Tot Sales</abbr>
                        </th>
                        <th scope="col" class="right cattle-cwt">
                            <abbr title="Total Expenses Less Sales">Tot Exp Less Sales</abbr>
                        </th>
                    </tr>
                </thead>
                <tbody>
                ${props.data.map(this.locationResultsRow).join('')}
                </tbody>
                <tfoot>                
                    <tr>
                        <th scope="row" class="total" colspan="5">Total</th>
                        <td class="footer-total receive">${displayNumber(
                            total.receive,
                            1
                        )}</td>
                        <td class="footer-total live">${displayNumber(
                            total.live,
                            1
                        )}</td>
                        <td class="footer-total ship">${displayNumber(
                            total.shipped,
                            1
                        )}</td>
                        <td class="footer-total dead">${displayNumber(
                            total.dead,
                            1
                        )}</td>
                        <td class="footer-total average-in-weight">${displayNumber(
                            total.weights.inWeight / total.receive,
                            0
                        )}</td>
                        <td class="footer-total average-in-weight">${displayNumber(
                            total.weights.curWeight / total.live,
                            0
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.weights.dof / total.receive,
                            0
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.cattleCost,
                            2
                        )}</td>
                        <td></td>
                        <td class="footer-total dof">${displayNumber(
                            total.cog,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.sell,
                            2
                        )}</td>
                        <td class="footer-total dof">${displayNumber(
                            total.pl,
                            2
                        )}</td>               
                        <td class="footer-total dof">${displayNumber(
                            total.yard,
                            2
                        )}</td>                
                        <td class="footer-total dof">${displayNumber(
                            total.totalExp,
                            2
                        )}</td>                
                        <td class="footer-total dof">${displayNumber(
                            total.totalSales,
                            2
                        )}</td>                
                        <td class="footer-total dof">${displayNumber(
                            total.totalExpLessSales,
                            2
                        )}</td>
                    </tr>
                </tfoot>
                </table>
                </div>
    </div>
  </div>            
        `
    }

    connectedCallback() {}

    render() {}
}

customElements.define('mt-iv-report', MTInventoryValuationReport)
